<template>
    <ac-modal title="Invoice Payment" ref="modalRef" :size-class="'modal-lg'" data-keyboard="false" data-backdrop="static">
        <template v-if="widgetReady">
            <div class="row">
                <div v-if="!isCompanyEntity" class="col-md-12">
                    <p><span style="min-width: 12px;">Name: </span>{{ fullName }}</p>
                    <p><span style="min-width: 12px;">DOB: </span>{{ birthDate }}</p>
                    <p><span style="min-width: 12px;">Email: </span>{{ consumer.emailAddress }}</p>
                    <p style="font-weight: bold!important;">Collect Amount: {{ grandTotal | currency }}</p>
                </div>
                <div v-else class="col-md-12">
                    <p><span style="min-width: 12px;">Company: </span>{{ company.name }}</p>
                    <p><span style="min-width: 12px;">Contact: </span>{{ fullName }}</p>
                    <p><span style="min-width: 12px;">Email: </span>{{ this.emailAddress }}</p>
                    <p style="font-weight: bold!important;">Collect Amount: {{ grandTotal | currency }}</p>
                </div>
            </div>
            <div class="row" v-if="!updateCC">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <input type="checkbox" class="filled-in" id='debt-ver-check' v-model="memberAgrees">
                        <label for="debt-ver-check" style="text-align: left">
                            {{ acknowledgement }} {{ new Date() | shortDate }}
                        </label>
                    </div>
                    <div class="col-md-12">
                        <div class="alert alert-info">
                            {{ selectedCardDisplay }}
                        </div>
                    </div>
                    <p>
                        To update the {{isCompanyEntity? "group's" : "primary member's" }} payment method click
                        <a style="cursor: pointer; color: blue;" @click.prevent="updateCC = true">here</a>.
                    </p>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12" v-if="ccWidgetReady">
                    <ac-current-credit-cards v-model="ccVm" ref="currentCCsComponent" :needsSelect="true" @delete="deleteCreditCard"
                        @save="saveCreditCard" @default="defaultCreditCard" @select="selectCreditCard" @toggleButtons="toggleButtons">
                    </ac-current-credit-cards>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="modal-footer" v-if="!hideButtons">
                        <div class="button-box">
                            <div v-if="updateCC">
                                <ac-button class="btn btn-red btn-sm" :action="cancelCreditCardUpdate">
                                    CANCEL
                                </ac-button>
                            </div>
                            <div v-else>
                                <ac-button class="btn btn-sm btn-red" :action="closeModal">CANCEL</ac-button>
                                <ac-button class="btn btn-sm btn-green" :action="collectPayment">PAY</ac-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
import { common } from "@/global/common";
import { api } from "@/global/framework/api"
import { notifications } from "@/global/notifications.js";
import moment from 'moment';
import AcButton from "../../global/customHtmlElements/AcButton.vue";
import AcCurrentCreditCards from "../custom/AcCurrentCreditCards.vue";
import {consumerPaymentMethodMixin} from "../shared/mixins/consumerPaymentMethodMixin.js";

export default {
    name: "CollectPaymentModal",
    components: { AcCurrentCreditCards, AcButton },
    mixins: [consumerPaymentMethodMixin],
    data() {
        return {
            widgetReady: false,
            ccWidgetReady: true,
            isProviderEntity: false,
            isCompanyEntity: false,
            invoice: null,
            providerEntityId: 0,
            consumer: null,
            company: null,
            fullName: '',
            emailAddress: '',
            birthDate: null,
            grandTotal: 0,
            memberAgrees: false,
            ccVm: {},
            updateCC: false,
            selectedCardDisplay: null,
            hasCard: false,
            defaultCC: null,
            selectedCC: null,
            hideButtons: false,
        };
    },
    computed: {
        acknowledgement() {
            if (this.isProviderEntity)
                return 'I agree, acknowledge and attest that I have been explicitly and directly provided authorization and consent from the member attached to this invoice to collect payment via credit/debit card on ';
            else
                return 'I agree, acknowledge and attest that I am providing authorization and consent to collect payment via credit/debit card on ';
        }
    },
    methods: {
        async showModal(data) {     
            if (data.providerEntityId != null && data.providerEntityId != undefined) {                
                this.isProviderEntity = true;
                [this.invoice, this.consumer] = await Promise.all([
                    api.getDataWithTwoIds('Invoice', data.invoiceId, 'GetInvoiceByIdForProvider', data.providerEntityId),
                    api.getDataWithTwoIds('Invoice', data.invoiceId, 'GetConsumerInfoByInvoiceIdForProvider', data.providerEntityId)
                ])
                this.setConsumerInfo(this.consumer);
                await this.getCreditCardInfo();
            }
            else if (data.companyId != null && data.companyId != undefined) {
                this.isCompanyEntity = true;
                [this.invoice, this.company] = await Promise.all([
                    api.getDataWithTwoIds('Invoice', data.invoiceId, 'GetInvoiceByIdForCompany', data.companyId),
                    api.get('Company', data.companyId, 'GetCompanyById'),
                ]);
                await this.getCreditCardInfo();
                this.setCompanyInfo(this.company);
            }
            else {                
                [this.invoice, this.consumer] = await Promise.all([
                    api.getDataWithTwoIds('Consumer', data.consumerId, 'GetInvoiceByIdForConsumer', data.invoiceId),
                    api.getDataWithTwoIds('Consumer', data.consumerId, 'GetConsumerInfoByInvoiceIdForConsumer', data.invoiceId)
                ])
                this.setConsumerInfo(this.consumer);
                await this.getCreditCardInfo();
            }

            this.grandTotal = this.invoice.lineItems.reduce((acc, item) => acc + item.amount, 0);
            this.providerEntityId = this.invoice.providerEntityId;
            this.widgetReady = true;
            this.$refs.modalRef.open();
        },
        closeModal(status = false) {
            this.$refs.modalRef.close();
            this.$emit("modal-closed", status);
        },
        async saveCreditCard() {
            let cardData = await this.tryGettingCardData();

            if (cardData) {
                let result, url;

                if (this.isProviderEntity) {
                    url = `${this.providerEntityId}/SaveCreditCardInfo/${this.consumer.consumerId}`;
                    result = await api.post('ProviderPayments', url, cardData.updatedCard);
                }
                else if (this.isCompanyEntity) {
                    url = `${this.company.companyId}/SaveBillingInfo`;
                    result = await api.post('Company', url, cardData.updatedCard);
                }
                else {
                    url = `${this.consumer.consumerId}/SaveCreditCardInfo`;
                    result = await api.post('Consumer', url, cardData.updatedCard);
                }

                if (result) {
                    await this.refresh();
                }
            }
        },
        async deleteCreditCard(data){
            let result;
            if (this.isProviderEntity) {
                result = await api.post('ProviderPayments', `${this.providerEntityId}/DeleteCard/${this.consumer.consumerId}/${data.paymentMethodId}`);
            }
            else if (this.isCompanyEntity) {
                result = await api.post('Company', `${this.company.companyId}/DeleteCard/${data.paymentMethodId}`);
            }
            else {
                result = await api.post('Consumer', `${this.consumer.consumerId}/DeleteCard/${data.paymentMethodId}`);
            }
            if (result) {
                await this.refresh();
            }
        },
        async defaultCreditCard(data){
            let result;
            if (this.isProviderEntity) {
                result = await api.post('ProviderPayments', `${this.providerEntityId}/DefaultCard/${this.consumer.consumerId}/${data.paymentMethodId}`);
            }
            else if (this.isCompanyEntity) {
                result = await api.post('Company', `${this.company.companyId}/DefaultCard/${data.paymentMethodId}`);
            }
            else {
                result = await api.post('Consumer', `${this.consumer.consumerId}/DefaultCard/${data.paymentMethodId}`);
            }
            if (result) {
                await this.refresh();
            }
        },
        async selectCreditCard(paymentMethodId){
            this.hideButtons = true;
            this.selectedCC = this.ccVm.currentCards.find(x => x.paymentMethodId === paymentMethodId);            
            await this.refresh();
            this.updateCC = false;
            this.hideButtons = false;
        },
        async toggleButtons(data) {
            this.hideButtons = !data;
        },
        cancelCreditCardUpdate() {
            this.updateCC = false;
        },
        async collectPayment() {
            let result;
            if (this.memberAgrees && this.hasCard) {
                var paymentMethodId = this.selectedCC !== null ? this.selectedCC.paymentMethodId : this.defaultCC.paymentMethodId;
                if (this.isProviderEntity) {
                    result = await api.post('Invoice', `${this.invoice.invoiceId}/CollectInvoicePaymentForProvider/${this.providerEntityId}/${paymentMethodId}`);
                }
                else if (this.isCompanyEntity) {
                    result = await api.post('Company', `${this.company.companyId}/CollectInvoicePaymentForCompany/${this.invoice.invoiceId}/${paymentMethodId}`);                  
                }
                else {
                    result = await api.post('Consumer', `${this.consumer.consumerId}/CollectInvoicePaymentForConsumer/${this.invoice.invoiceId}/${paymentMethodId}`);
                }
                if (result) this.closeModal(true);
            }
            else {
                notifications.show({ title: "Failure!", message: "Must confirm member agrees to payment. Must have card on file." }, common.ACRESSA_NOTIFICATIONS.ERROR);
            }
        },
        async getCreditCardInfo() {
            if (this.isProviderEntity) {
                this.ccVm = await api.getDataWithTwoIds('ProviderPayments', this.invoice.providerEntityId, 'GetCreditCardInfoForPrimary', this.invoice.consumerId);
            }
            else if (this.isCompanyEntity) {
                this.ccVm = await api.get('Company', this.company.companyId, 'GetBillingInfo');
            }
            else {
                this.ccVm = await api.getData('Consumer', this.invoice.consumerId, 'GetCreditCardInfoForPrimary');
            }            
            let currCards = this.ccVm.currentCards;

            if (currCards === null) {
                this.selectedCardDisplay = "There is no card on file currently.";
            }
            else {
                this.defaultCC = currCards.find(x => x.isDefault);

                if(this.selectedCC !== null){
                    this.selectedCardDisplay = `Selected Card: ${this.selectedCC.brand}, ${this.selectedCC.maskedCardNumber}, expiring on ${this.selectedCC.expirationMonth}/${this.selectedCC.expirationYear}`;
                }
                else {
                    this.selectedCardDisplay = `Default Card: ${this.defaultCC.brand}, ${this.defaultCC.maskedCardNumber}, expiring on ${this.defaultCC.expirationMonth}/${this.defaultCC.expirationYear}`;
                }
                this.hasCard = true;
            }
        },
        setConsumerInfo(consumer) {
            let firstName = consumer.firstName.trim();
            let lastName = consumer.lastName.trim();
            this.fullName = `${firstName} ${lastName}`;
            this.birthDate = moment(consumer.birthDate).format('MM/DD/YYYY');
        },
        setCompanyInfo(company) {
            let firstName = this.ccVm.defaultContact.firstName.trim();
            let lastName = this.ccVm.defaultContact.lastName;
            this.fullName = `${firstName} ${lastName}`;
            this.emailAddress = this.ccVm.defaultContact.emailAddress;
        },
        async refresh(){       
            this.ccWidgetReady = false;     
            await this.getCreditCardInfo();
            this.ccWidgetReady = true;
        }
    },
}
</script>

<style scoped>
.modal-footer {
    padding-left: 0;
    padding-right: 0;
}
</style>